<template>
  <div>
    <div>
      <h4>
        {{ "applay_pay_text" | setText("Пожалуйста подтвердите оплату") }}
      </h4>
      <button @click="pay" class="btn btn-info mw">
        {{ "apply_pay" | setText("Подтвердить оплату") }}
      </button>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    done() {
      return (
        this.transaction &&
        this.transaction.system_confirmed &&
        this.transaction.client_confirmed
      );
    },
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  mounted() {
    setInterval(() => {
      this.timer--;
    }, 1000);
  },
  name: "filter",
  methods: {
    next() {
      this.$emit("setStep", null);
    },
    pay() {
      this.createTransaction({
        client_confirmed: 1,
        system_confirmed: 1,
        step: "done",
      });

      this.$emit("setStep", "done");
    },
  },
  data() {
    return {};
  },
};
</script>

